const facturaRenderer = () => (data, type, row) =>
    `${row.prefijo}-${row.consecutivo}`;

export { facturaRenderer };